// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2025 
import { IExpressionBuilder } from '../../../../CommonScripts/Abstractions';
import { Overlay } from './Overlay';
declare const ol: any;
/**
* Creates an intersect SIS expression.
* @export
* @extends Cadcorp.Web.Entities.GeognoSIS.ExpressionBuilderBase
*/
export class IntersectExpressionBuilder implements IExpressionBuilder {
    /**
    * @private
    * @property {ol.Feature} m_feature - A feature to create the expression from.
    */
    private m_feature: any;
    /**
    * @private
    * @property {Overlay} m_overlay - Overlay to perform queries on.
    */
    private m_overlay: Overlay;
    /**
    * Constructor.
    * @export
    * @constructor
    * @param {ol.Feature} feature The feature to use to query with
    * @param {Overlay} overlay The overlay to perform queries on
    */
    constructor(feature : any, overlay:Overlay) {
        this.m_feature = feature;
        this.m_overlay = overlay;
    }
    /**
    * @inheritdoc
    */
    createExpression(map) {
        const layerEpsg = this.m_overlay.epsgCode;
        const mapProjection = map.getView().getProjection();

        const destinationPrj = `EPSG:${layerEpsg}`;
        const needTransformation = (destinationPrj !== mapProjection.getCode());
        const format = new ol.format.GeoJSON();
        let geoJson;
        if (needTransformation) {
            const newGeom = this.m_feature.getGeometry().transform(mapProjection, destinationPrj);
            geoJson = format.writeGeometry(newGeom);
        }
        else {
            //extracting geoJson 
            geoJson = format.writeGeometry(this.m_feature.getGeometry(),
                { dataProjection: destinationPrj, featureProjection: mapProjection });
        }
        return `ST_Intersects(geometry,ST_GeomFromGeoJSON('${geoJson}',"${destinationPrj}"))`;
    }
    /**
    * @inheritdoc
    */
    destroy() {
        this.m_feature = null;
        this.m_overlay = null;
    }
};

